import { Link } from 'react-router-dom';
import { comics as allComics } from '@/mocks/comics';

interface ComicGridProps {
  categorySlug: string;
}

export default function ComicGrid({ categorySlug }: ComicGridProps) {
  const filteredComics =
    categorySlug === 'all'
      ? allComics
      : allComics.filter((c) => c.category === categorySlug);

  return (
    <section className="w-full py-10 md:py-14 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
            {categorySlug === 'all' ? '最新更新' : `${filteredComics.length > 0 ? '分类作品' : '暂无作品'}`}
          </h2>
          <Link
            to={`/category/${categorySlug}`}
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium cursor-pointer whitespace-nowrap transition-colors"
          >
            查看全部
            <i className="ri-arrow-right-s-line text-lg"></i>
          </Link>
        </div>

        {filteredComics.length === 0 ? (
          <div className="text-center py-20">
            <i className="ri-inbox-line text-5xl text-foreground-300"></i>
            <p className="mt-4 text-foreground-500">该分类暂无作品</p>
          </div>
        ) : (
          <div
            className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6"
            data-product-shop=""
          >
            {filteredComics.map((comic) => (
              <Link
                key={comic.id}
                to={`/article/${comic.id}`}
                className="group cursor-pointer"
              >
                <div className="aspect-[3/4] rounded-lg overflow-hidden bg-background-100 relative mb-3">
                  <img
                    src={comic.coverImage}
                    alt={comic.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                    title={`${comic.title} - 韩国漫画`}
                    loading="lazy"
                  />
                  <div className="absolute top-2 left-2">
                    {comic.isHot && (
                      <span className="inline-flex items-center gap-0.5 px-2 py-0.5 rounded-full bg-accent-500 text-white text-xs font-medium">
                        <i className="ri-fire-line"></i>热门
                      </span>
                    )}
                  </div>
                  <div className="absolute top-2 right-2">
                    <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-black/60 text-white text-xs">
                      {comic.rating}
                    </span>
                  </div>
                  {comic.status === 'completed' && (
                    <div className="absolute bottom-2 left-2">
                      <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-secondary-500 text-white text-xs">
                        已完结
                      </span>
                    </div>
                  )}
                </div>
                <h3 className="text-sm md:text-base font-medium text-foreground-800 group-hover:text-primary-500 transition-colors truncate">
                  {comic.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1">
                  {comic.author} · 共{comic.chapters}话
                </p>
              </Link>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}